function isNativeApp() {
  return document.documentElement.hasAttribute('data-turbo-native-app');
}

function sendBridgeMessage(eventName, data = {}) {
  if (!isNativeApp()) return;

  // Android - use Hotwire Native bridge
  if (window.HotwireNative?.web) {
    window.HotwireNative.web.send({
      component: "nativeApp",
      event: eventName,
      data: {
        ...data,
        metadata: { url: window.location.href }
      }
    });
  }
  // iOS - use WebKit message handlers
  if (window.webkit?.messageHandlers?.nativeApp) {
    window.webkit.messageHandlers.nativeApp.postMessage({ name: eventName, ...data });
  }
}

function triggerNativeReviewPrompt() {
  if (!isNativeApp()) return;
  sendBridgeMessage("trigger_review_prompt");
}

// Expose the function globally for Alpine.js
window.triggerNativeReviewPrompt = triggerNativeReviewPrompt;



